import React, { useEffect } from 'react'

import { useParams } from 'react-router-dom'

import { SimulatorHeader } from './SimulatorHeader/SimulatorHeader'
import { SimulatorInterface } from './SimulatorInterface/SimulatorInterface'

import { useAppDispatch, useAppSelector } from 'common/hooks'
import { fetchCategories, selectCategories, selectTaskByTaskId } from 'features/dashboard'

type PropsType = {}

export const Simulator = ({}: PropsType) => {
  const dispatch = useAppDispatch()
  const { id } = useParams()

  const task = useAppSelector(state => selectTaskByTaskId(state, id!))
  const categories = useAppSelector(selectCategories)

  useEffect(() => {
    if (categories.length === 0) {
      dispatch(fetchCategories())
    }
  }, [])

  if (categories.length === 0) {
    return null
  }

  return (
    <section>
      <SimulatorHeader id={id!} />
      <SimulatorInterface task={task!} />
    </section>
  )
}
